import { createClient } from '@/shared/api';
import type { CheckDeviceConnectionQuery, CheckDeviceConnectionQueryVariables } from '@/shared/api';
import CHECK_DEVICE_CONNECTION_QUERY from '../queries/checkDeviceConnection';

/**
 * Verifies that a device is reachable before it is used for a study. Runs the checkDeviceConnection query and throws the returned message when the check does not report success.
 *
 * @param input - Query input identifying the device to probe.
 * @returns A promise resolving once the connection check has passed.
 */
const fetchCheckDeviceConnection = async (
  input: CheckDeviceConnectionQueryVariables['input'],
): Promise<void> => {
  const client = createClient();
  const result = await client.query<
    CheckDeviceConnectionQuery,
    CheckDeviceConnectionQueryVariables
  >({
    query: CHECK_DEVICE_CONNECTION_QUERY,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { checkDeviceConnection } = data;
  if (!checkDeviceConnection.isSuccess) {
    throw new Error(checkDeviceConnection.message ?? undefined);
  }
};

export default fetchCheckDeviceConnection;
